import { useGlobalStore } from '@digiwedge/global-state';

type TokenAccessor = () => string | undefined;

let getToken: TokenAccessor = () => useGlobalStore.getState().token;

export function __setApiTokenAccessor(accessor: TokenAccessor) {
  getToken = accessor;
}

export function __resetApiTokenAccessor() {
  getToken = () => useGlobalStore.getState().token;
}

export async function apiGet<T>(url: string): Promise<T> {
  const token = getToken();
  const r = await fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!r.ok) throw new Error(await r.text());
  return (await r.json()) as T;
}

export async function apiPost<T = unknown>(url: string, body?: unknown): Promise<T> {
  const token = getToken();
  const r = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!r.ok) throw new Error(await r.text());
  try {
    return (await r.json()) as T;
  } catch {
    return undefined as unknown as T;
  }
}

export async function apiDelete<T = unknown>(url: string): Promise<T> {
  const token = getToken();
  const r = await fetch(url, {
    method: 'DELETE',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!r.ok) throw new Error(await r.text());
  try {
    return (await r.json()) as T;
  } catch {
    return undefined as unknown as T;
  }
}

export async function apiPut<T = unknown>(url: string, body: unknown): Promise<T> {
  const token = getToken();
  const r = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (!r.ok) throw new Error(await r.text());
  try {
    return (await r.json()) as T;
  } catch {
    return undefined as unknown as T;
  }
}
